<form class="rows" *ngrxLet="store.vm$ as vm" [formGroup]="store.form">
  <div class="row">
    <div class="column">
      <nty-title formControlName="title" placeholder="Title your Headline" />
      @if (hasRequiredError('title') && vm.isSubmitted) {
        <nty-form-error>Give your Headline a title.</nty-form-error>
      }
    </div>
  </div>

  <div class="row description-row">
    <div class="column">
      <nty-description
        formControlName="description"
        placeholder="Enter a description {{ isOptional(store.form.controls['description']) ? '(optional)' : '' }}" />
    </div>
  </div>

  <div class="row">
    <div class="column">
      <ion-label class="label terra-body">Team</ion-label>
      <nty-team-multi-select
        class="teams-selector"
        formControlName="teams"
        [teams]="vm.teams"
        [hasAll]="true"
        [ntyIcon]="'users-three--regular.svg'"
        [hasAll]="true" />
    </div>
  </div>

  <div class="row">
    <div class="column">
      <ion-label class="label terra-body">Owner</ion-label>
      <nty-user-single-select [users]="vm.usersOnTeam" formControlName="userId" class="input" />
    </div>
  </div>

  <div class="row">
    <nty-attachments #attachments [deferUpload]="true" [parentType]="attachmentType" />
  </div>

  @if (vm.hasLinkedItem) {
    <div class="row">
      <ion-toggle slot="start" formControlName="createLinkedItem" labelPlacement="end">
        <span class="label terra-body">Create Linked Item</span>
      </ion-toggle>
    </div>
  }
</form>
